<template>
  <div :class="{ 'flex flex-row-reverse gap-4': vertical }">
    <Swiper
      class="rounded-lg max-h-[648px] [&_.swiper-pagination]:hidden md:[&_.swiper-pagination]:block"
      style="
        --swiper-pagination-bullet-size: 12px;
        --swiper-pagination-color: #fff;
        --swiper-pagination-bullet-inactive-color: #fff;
      "
      :style="{
        '--swiper-pagination-bottom': vertical ? 'unset' : '24px',
        '--swiper-pagination-right': vertical ? '24px' : 'unset',
      }"
      :class="{
        'aspect-[3/4] [&>_*.swiper-pagination]:flex [&>_*.swiper-pagination]:!flex-col [&>_*.swiper-pagination]:overflow-visible':
          vertical,
      }"
      :pagination="{
        dynamicBullets: true,
        clickable: true,
      }"
      :thumbs="{ swiper: thumbsSwiper }"
      :modules="modules"
      :loop="false"
      :direction="vertical ? 'vertical' : 'horizontal'"
      @swiper="setGallerySwiper"
      @slideChange="onSlideChange"
    >
      <SwiperSlide
        v-for="(item, index) in gallery"
        class="cursor-pointer relative dark:bg-white/10 bg-black-50 rounded-lg"
        :class="{
          'aspect-video': !['mp4', 'mov', 'flv', 'mov'].includes(
            getExtension(item),
          ),
        }"
        :key="index"
        @click="
          () => {
            if (!['mp4', 'mov', 'flv', 'mov'].includes(getExtension(item))) {
              lightboxOpened = true
              indexRef = images.findIndex((i) => i === item)
            }
          }
        "
      >
        <div
          v-if="
            ['mp4', 'mov', 'flv', 'mov'].includes(getExtension(item)) ||
            item.video_source
          "
          class="bg-black-950 flex items-center justify-center h-full"
        >
          <VideoPlayer
            class="swiper-no-swiping"
            :src="item.path"
            :controls="true"
            :context="item"
            @mounted="setPlayer"
          />
        </div>
        <div v-else>
          <img
            class="absolute left-1/2 -translate-x-1/2 w-full object-contain object-center h-full mx-auto"
            :src="
              getMediaPathItem(item, item.collection + '-optimized') ||
              getMediaPathItem(item, item.collection)
            "
            alt="alt"
          />
          <img
            v-show="item?.preview"
            class="absolute w-full h-full inset-0 z-[-1]"
            :src="previewToDataURL(item?.preview || '')"
            alt="preview"
          />
        </div>
      </SwiperSlide>
    </Swiper>
    <div v-if="gallery.length > 1" class="relative">
      <Swiper
        v-if="thumbs"
        :loop="false"
        :spaceBetween="10"
        :slidesPerView="!vertical ? 3 : 4"
        :breakpoints="{
          640: {
            slidesPerView: 4,
          },
        }"
        :freeMode="true"
        :direction="vertical ? 'vertical' : 'horizontal'"
        :slideToClickedSlide="true"
        :watchSlidesProgress="true"
        :modules="modules"
        class="mySwiper relative [&_.swiper-slide-thumb-active]:dark:border-brand-1 [&_.swiper-slide-thumb-active]:border-primary-500 [&_.swiper-slide-thumb-active]:opacity-100"
        :class="{ 'w-[86px]': vertical, 'mt-2': !vertical }"
        @swiper="setThumbsSwiper"
      >
        <SwiperSlide
          v-for="(item, index) in gallery"
          :key="index"
          class="border-2 border-transparnet dark:bg-white/10 bg-black-50 opacity-60 aspect-video rounded overflow-hidden cursor-pointer"
          :class="{ 'min-h-[115px] max-h-[115px]': vertical }"
        >
          <div
            v-if="['mp4', 'mov', 'flv', 'mov'].includes(getExtension(item))"
            class="bg-black-950 flex justify-center h-full items-center"
          >
            <IconPlayerPlayFilled class="text-white size-6" />
          </div>
          <div v-else>
            <img
              class="absolute left-1/2 -translate-x-1/2 w-full object-contain object-center h-full mx-auto"
              :src="
                getMediaPathItem(item, item.collection + '-optimized') ||
                getMediaPathItem(item, item.collection)
              "
              alt="alt"
            />
            <img
              v-show="item.preview"
              class="absolute w-full h-full inset-0 z-[-1]"
              :src="previewToDataURL(item.preview)"
              alt="preview"
            />
          </div>
        </SwiperSlide>
      </Swiper>
      <button
        v-if="!vertical && pos < 1 && !hideArrows"
        @click="gallerySwiper.slideNext"
        class="bg-white dark:bg-white/20 dark:text-white cursor-pointer absolute z-30 text-black-600 right-6 md:-right-10 top-1/2 -translate-y-1/2 h-7 w-7 rounded-md"
      >
        <IconChevronRight
          class="bg-black bg-opacity-10 p-0.5 w-7 h-7 rounded-md"
        />
        <span class="sr-only" v-text="'next'" />
      </button>
      <button
        v-if="vertical && pos < 1 && !hideArrows"
        @click="gallerySwiper.slideNext"
        class="absolute z-30 top-8 w-7 h-7 left-1/2"
        :style="`transform: translate(-50%, ${115 * gallery.length}px)`"
      >
        <IconChevronCompactDown
          class="p-0.5 w-7 h-7 hover:scale-110 transition-transform"
        />
        <span class="sr-only" v-text="'next'" />
      </button>
      <button
        v-if="!vertical && pos > 0 && !hideArrows"
        @click="gallerySwiper.slidePrev()"
        class="bg-white dark:bg-white/20 dark:text-white cursor-pointer absolute z-30 text-black-600 left-6 md:-left-10 top-1/2 -translate-y-1/2 h-7 w-7 rounded-md"
      >
        <IconChevronLeft
          class="p-0.5 bg-black bg-opacity-10 h-7 w-7 rounded-md"
        />
        <span class="sr-only" v-text="'previous'" />
      </button>
      <button
        v-if="vertical && pos > 0 && !hideArrows"
        @click="gallerySwiper.slidePrev()"
        class="absolute z-30 -top-[26px] -translate-x-1/2 w-7 h-7 left-1/2"
      >
        <IconChevronCompactUp
          class="p-0.5 w-7 h-7 hover:scale-110 transition-transform"
        />
        <span class="sr-only" v-text="'previous'" />
      </button>
    </div>
    <VueEasyLightbox
      :visible="lightboxOpened"
      :imgs="
        images.map(
          (i) =>
            getMediaPathItem(i, i.collection + '-optimized') ||
            getMediaPathItem(i, i.collection),
        )
      "
      :index="indexRef"
      @hide="lightboxOpened = false"
    >
      <template #close-btn="{ close }">
        <button
          class="w-9 h-9 rounded-full absolute right-3 top-3 flex bg-secondary/50 text-white"
          @click="close"
        >
          <IconX class="m-auto" />
        </button>
      </template>

      <template #prev-btn="{ prev }">
        <button
          v-show="gallery && gallery.length > 1"
          class="pointer-events-auto top-1/2 absolute left-2 md:left-3 transform -translate-y-1/2 text-white md:size-16 size-8 bg-black/20 flex justify-center items-center rounded-full"
          @click="prev"
        >
          <IconChevronLeft class="size-4 md:size-8" />
        </button>
      </template>

      <template #next-btn="{ next }">
        <button
          v-show="gallery && gallery.length > 1"
          class="pointer-events-auto top-1/2 absolute right-2 md:right-3 transform -translate-y-1/2 text-white md:size-16 size-8 bg-black/20 flex justify-center items-center rounded-full"
          @click="next"
        >
          <IconChevronRight class="size-4 md:size-8" />
        </button>
      </template>

      <template #toolbar="{ toolbarMethods }">
        <div
          class="absolute flex left-1/2 transform -translate-x-1/2 bottom-2 bg-white dark:bg-primary-950 rounded px-2 shadow shadow-black/10 text-black dark:text-white"
        >
          <button
            class="p-2 hover:text-primary transition-colors"
            @click="toolbarMethods.zoomIn"
          >
            <IconZoomIn />
          </button>
          <button
            class="p-2 hover:text-primary transition-colors"
            @click="toolbarMethods.zoomOut"
          >
            <IconZoomOut />
          </button>
          <button
            class="p-2 hover:text-primary transition-colors"
            @click="toolbarMethods.resize"
          >
            <IconMaximize />
          </button>
          <button
            class="p-2 hover:text-primary transition-colors"
            @click="toolbarMethods.rotateLeft"
          >
            <IconRotate />
          </button>
          <button
            class="p-2 hover:text-primary transition-colors"
            @click="toolbarMethods.rotateRight"
          >
            <IconRotateClockwise />
          </button>
        </div>
      </template>
    </VueEasyLightbox>
  </div>
</template>

<script setup>
import { useScrollLock } from '@vueuse/core'
import { sortBy } from 'lodash-es'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import { FreeMode, Pagination, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { computed, ref, watch } from 'vue'
import VueEasyLightbox from 'vue-easy-lightbox'

import {
  IconChevronCompactDown,
  IconChevronCompactUp,
  IconChevronLeft,
  IconChevronRight,
  IconMaximize,
  IconPlayerPlayFilled,
  IconRotate,
  IconRotateClockwise,
  IconX,
  IconZoomIn,
  IconZoomOut,
} from '@tabler/icons-vue'

import VideoPlayer from '@/components/VideoPlayer.vue'
import { getMediaPath, getMediaPathItem } from '@/utils/media.js'
import { previewToDataURL, thumbHashToDataURL } from '@/utils/thumbhash.js'

const isLocked = useScrollLock(document)

const props = defineProps({
  media: {
    type: Array,
    default: [],
  },
  collections: {
    type: Array,
    default: ['default', 'gallery'],
  },
  thumbs: {
    type: Boolean,
    default: true,
  },
  vertical: {
    type: Boolean,
    default: false,
  },
  hideArrows: {
    type: Boolean,
    default: false,
  },
})

const thumbsSwiper = ref(null)
const setThumbsSwiper = (tSwiper) => {
  thumbsSwiper.value = tSwiper
}

const modules = [FreeMode, Pagination, Thumbs]

const gallery = computed(() =>
  sortBy(
    props.media.filter((item) => props.collections.includes(item.collection)),
    ['order'],
  ),
)

const images = computed(() =>
  gallery.value.filter((i) => props.collections.includes(i.collection)),
)

const gallerySwiper = ref(null)
const setGallerySwiper = (gSwiper) => {
  gallerySwiper.value = gSwiper
  gallerySwiper.value.on('progress', (s, p) => {
    pos.value = p
  })
}

const pos = ref(0)

const lightboxOpened = ref(false)
const indexRef = ref(0)

watch(lightboxOpened, (value, oldValue) => {
  isLocked.value = value
})

const players = []

function setPlayer(e) {
  players.push(e.player)
}

function onSlideChange() {
  if (players.length) {
    players.forEach((item) => {
      try {
        item.pause()
      } catch (e) {
        console.log(e)
      }
    })
  }
}

function getExtension(item) {
  return item?.extension ?? item?.path.split(/[#?]/)[0].split('.').pop().trim()
}
</script>
